<div class="cookies-block">
  <img class="cookies-block--icon"
       id="closeCookies"
       src="./assets/img/icons/close.svg"
       alt="Close Cookies"
       (click)="visibleCookieToogle()">
  <p>
    La web de Boost hace uso de sus cookies propias y de terceros con el fin de mejorar nuestros servicios. Si continúas navegando, consideramos que aceptas su uso.
  </p>
  <p>Si deseas obtener más información, puedes acceder a la
    <a routerLink="politica-proteccion-datos">
      Política de Privacidad de Datos.
    </a>
  </p>
  <button class="btn btn--black" id="btn_cookies"
          (click)="visibleCookieToogle()">
    Continuar
  </button>
</div>
